import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Body from 'syf-component-library/ui/typography/Body';
import { MessageBoxSyf } from './subcomponents';
const MessageBox = ({ type, icon, title, body }) => {
    return (_jsxs(MessageBoxSyf, { type: type, "data-cy": "message-box-container", icon: icon, children: [_jsx(Body, { weight: "bold", children: title }), _jsx(Body, { children: body })] }));
};
export default MessageBox;
